import { Link, createFileRoute } from '@tanstack/react-router';
import { Card, buttonVariants, Wordmark } from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

/*
 * Where somebody lands whose organisation is not on the web app: they are
 * signed in, from a practice link, and the API answers nothing else. Outside
 * `_app` because the shell around it would be a rail of pages they cannot open.
 */
export const Route = createFileRoute('/unavailable')({
  component: UnavailablePage,
});

export function UnavailablePage() {
  return (
    <main className='mx-auto flex min-h-dvh max-w-150 flex-col gap-6 px-6 py-12'>
      <div>
        <Wordmark registered className='h-8' />
      </div>

      <Card>
        <h1 className='text-xl font-semibold tracking-tight'>{m.unavailable_title()}</h1>
        <p className='mt-3 text-base text-ink-muted'>{m.unavailable_body()}</p>
      </Card>

      {/* Two people on one laptop: the other one needs a way to their own sign-in. */}
      <div>
        <Link to='/logout' className={buttonVariants({ variant: 'link', size: 'sm' })}>
          {m.unavailable_sign_out()}
        </Link>
      </div>
    </main>
  );
}
